const contractAddress = {
    "BNB":"0x667a378817EE1bD15e6cB3616b275a5D3b4f3aE3",
    "GLP":"0x94ade5A1dD2349E604AEB2c0b2CFac486C7e19Ae",
    "Router":"0x10ED43C718714eb63d5aA57B78B54704E256024E"
}


export default contractAddress